export default {
  finish: '今日完成',
  title: '请按要求标注下面一段语音。',
  pause: '暂停',
  play: '播放',
  stop: '停止',
  zoomin: '放大',
  zoomout: '缩小',
  add: '增加',
  loading: '拼命加载中',
  current: '当前',
  editor: '备注',
  save: '保存',
  js: {
    valid: '有效',
    noValid: '无效',
    errVoice: '音频加载失败，请确认音频是否有效',
    error: '失败',
    errMessage: '您的浏览器可能不支持暂时保存',
    success: '成功',
    sucMessage: '保存成功',
    validinfo1: '请完成全局有效性判断',
    validinfo2: '结束时间',
    validinfo3: '第',
    validinfo4: '个全局题目未完成',
    validinfo5: '段音频未转写',
    validinfo6: '段音频题目答案不一致',
    validinfo7: '段音频'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/voiceExample.js